module.exports = __webpack_public_path__ + "img/caimanyouzeng@2x.png?v=47900b33";